import { createMuiTheme, Theme } from '@material-ui/core';
import { muiTheme } from '@lifesize/ux-assets';
import _merge from 'lodash/merge';

muiTheme.overrides = _merge(muiTheme.overrides, {
  MuiInput: {
    underline: {
      '&:after': {
        transition: 'none'
      }
    }
  },
  MuiTypography: {
    button: {
      textTransform: 'none'
    }
  }
});
export const theme: Theme = createMuiTheme(muiTheme);
